import { PILLARS } from "@/lib/content";

const TRISM = PILLARS[5];

const OPTIONS = [
  { id: "A", name: "Soft Sage", hex: "#EAEEE3", bg: "#EAEEE3", border: "border-[#9CA888]/60", kicker: "text-[#5E6B50]", iconBox: "bg-[#9CA888]/25 text-[#5E6B50]", card: "bg-white border-[#9CA888]/40" },
  { id: "B", name: "Warm Stone", hex: "#EFEAE0", bg: "#EFEAE0", border: "border-[#8A5730]/35", kicker: "text-[#8A5730]", iconBox: "bg-[#8A5730]/12 text-[#8A5730]", card: "bg-white border-[#8A5730]/20" },
  { id: "C", name: "Deeper Gold-Cream", hex: "#F6EAD2", bg: "#F6EAD2", border: "border-[#E8AA68]/70", kicker: "text-[#8A5730]", iconBox: "bg-[#E8AA68]/35 text-[#8A5730]", card: "bg-white border-[#E8AA68]/45" },
  { id: "D", name: "Current (Cream-Gold)", hex: "#FBF2E1", bg: "#FBF2E1", border: "border-[#E8AA68]/60", kicker: "text-[#8A5730]", iconBox: "bg-[#E8AA68]/30 text-[#8A5730]", card: "bg-white border-[#E8AA68]/40" },
];

const Panel = ({ o }) => (
  <div data-testid={`trism-option-${o.id}`}>
    <div className="flex items-center gap-3 mb-3">
      <span className="inline-block w-5 h-5 rounded-full border border-black/10" style={{ backgroundColor: o.hex }} />
      <span className="font-mono2 text-[11px] uppercase tracking-[0.22em] text-[#8A5730]">Option {o.id} · {o.name}</span>
      <span className="font-mono2 text-[11px] text-[#3E2818]/45">{o.hex}</span>
    </div>

    {/* Dock item + stage side by side */}
    <div className="grid lg:grid-cols-[0.32fr_1fr] gap-4 items-start">
      {/* mini dock item */}
      <div className={`rounded-xl border ${o.border} px-4 py-3`} style={{ backgroundColor: o.bg }}>
        <span className={`font-mono2 text-[9px] uppercase tracking-[0.2em] ${o.kicker}`}>Trust</span>
        <h3 className="font-display text-base font-medium text-[#3E2818] leading-tight">{TRISM.title}</h3>
      </div>

      {/* stage panel */}
      <div className={`rounded-2xl border ${o.border} p-6`} style={{ backgroundColor: o.bg }}>
        <span className={`font-mono2 text-[10px] uppercase tracking-[0.25em] ${o.kicker}`}>Trust</span>
        <h3 className="font-display text-2xl font-medium text-[#3E2818] tracking-tight mt-1">{TRISM.title}</h3>
        <p className="text-sm text-[#3E2818]/65 mt-2 max-w-xl leading-relaxed">{TRISM.promise}</p>
        <div className="grid sm:grid-cols-3 gap-3 mt-5">
          {TRISM.features.map((f) => (
            <div key={f.title} className={`rounded-xl p-4 border ${o.card}`}>
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-3 ${o.iconBox}`}>
                <f.icon size={15} strokeWidth={1.9} />
              </div>
              <p className="text-[13px] font-semibold text-[#3E2818] leading-snug">{f.title}</p>
              <p className="text-[11px] text-[#3E2818]/55 mt-1.5 leading-snug">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default function TrismOptions() {
  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A5730]">AI TRiSM · Background Options</p>
        <h1 className="font-display text-2xl lg:text-3xl font-medium mt-2 tracking-tight text-[#3E2818]">Pick a background for AI TRiSM</h1>
        <p className="text-sm text-[#3E2818]/60 mt-3 max-w-2xl leading-relaxed">
          Each option shows the AI TRiSM dock item and stage panel with its accents. Tell me the letter and I&rsquo;ll apply it to the live Platform section (dock + stage stay matched).
        </p>

        <div className="mt-10 space-y-10">
          {OPTIONS.map((o) => <Panel key={o.id} o={o} />)}
        </div>
      </div>
    </div>
  );
}
